import MuiAutocomplete from "@mui/material/Autocomplete";

const Autocomplete: React.FC<React.ComponentProps<typeof MuiAutocomplete>> = (
  props
) => {
  return <MuiAutocomplete {...props} />;
};

export default Autocomplete;
